import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { CustomerSelectComponent } from './customer-select.component';
import { AuthService } from '../../auth/auth.service';
import { AsyncPipe } from '@angular/common';
import { AuthCustomer } from '../../auth/models/auth-customer';
import { map, tap } from 'rxjs/operators';
import { PushService } from '@fc-core/platform/push/push.service';
import { User } from '@fc-core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fc-user-customer-select',
  imports: [CustomerSelectComponent, AsyncPipe],
  template: `
    <fc-customer-select
      [label]="'Switch company'"
      [customers]="customers$ | async"
      [customersLoading]="customersLoading"
      [currentCustomerId]="currentCustomerId"
      (selectCustomer)="switchCustomer($event)"
    ></fc-customer-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCustomerSelectComponent implements OnInit {
  auth = inject(AuthService);
  pushService = inject(PushService);
  customers$: Observable<AuthCustomer[]>;
  customersLoading = false;
  currentCustomerId = this.auth.tokenData?.customer_id;

  ngOnInit() {
    this.getCustomers();
  }

  switchCustomer(customer: AuthCustomer) {
    if (!customer.customerId) return;
    this.auth
      .switchCustomer(customer.customerId)
      .pipe(map((user: User | null) => this.onSuccessfulCustomerSwitch(user)))
      .subscribe();
  }

  getCustomers() {
    const token = this.auth.token;
    if (!token) return;
    this.customersLoading = true;
    this.customers$ = this.auth
      .getCustomers(token)
      .pipe(tap(() => (this.customersLoading = false)));
  }

  onSuccessfulCustomerSwitch(user: User | null) {
    if (user == null) return;
    this.pushService.init();
    // A full load, not navigate()+reload(): navigate() is async, so reload()
    // would re-open the previous company's page (e.g. another company's user).
    window.location.assign('/map');
  }
}
